import creditCardType from 'credit-card-type'

export const allowedCardTypes = ['maestro', 'mastercard']

export default {
  name: 'card_brand',
  validator(value) {
    const card = creditCardType(value).pop()

    if (card) {
      return allowedCardTypes.includes(card.type)
    }
    return false
  }
}
